import { useEffect, useRef, useState } from "react";
import { GetAllClientesList } from "../../../../hooks/getListClientes";
import { GetAllPartesList } from "../../../../hooks/getPartesList";
import { ExpandMore } from "@mui/icons-material";
import { Alert, Autocomplete, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, TextField } from "@mui/material";
import { useLoading } from "../../../../components/Loading/useLoading";
import moment from "moment";

export const LogisticaFiltros = ({ searchData, exportGeneral, exportDetalle,canDownXlsx }) => {

  const { getAllPartesListMutation } = GetAllPartesList();
  const { getAllClientesListMutation } = GetAllClientesList();
  const formOrden = useRef(null);
  const { setAppLoading } = useLoading();
  const [partes, setPartes] = useState([])
  const [isOpen, setIsOpen] = useState(true);
  const [clientes, setClientes] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [partesSelect, setPartesSelect] = useState([]);
  const [clienteSelect, setClienteSelect] = useState(null);
  const [statusSelect, setStatusSelect] = useState([1, 2, 3, 4, 5])
  const [final, setFinal] = useState(moment().format('YYYY-MM-DD'));
  const [inicio, setInicio] = useState(moment().format('YYYY-MM-DD'));

  const toggleCollapser = () => {
    setIsOpen(!isOpen);
  };

  const get_clientes = () => {
    getAllClientesListMutation({}, {
      onSuccess: (data) => {
        data.sort((a, b) => {
          return a.label.localeCompare(b.label);
        })
        setClientes(data)
      },
      onError: (error) => {
        console.log(error)
      }
    })
  }
  const get_partes = () => {
    setAppLoading(true);
    getAllPartesListMutation(
      {},
      {
        onSuccess: (data) => {
          setPartes(data);
        },
        onError: (error) => {
          console.log(error);
        },
        onSettled: () => {
          setAppLoading(false);
        }
      }
    );
  };
  const changeClient = (newValue) => {
    setPartesSelect([]);
    setClienteSelect(newValue)
  }
  const changeStatus = (value) => {
    let status = [...statusSelect];
    let exist = statusSelect.some(id => id === value);
    if (exist) {
      status = status.filter(item => item !== value);
    } else {
      status.push(value)
    }
    setStatusSelect(status)
  }
  useEffect(() => {
    get_clientes();
    get_partes();
  }, []);

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const sumbmitFiltro = () => {
    if (!clienteSelect || partesSelect.length === 0 || !partes || !inicio || !final || statusSelect.length === 0) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
      console.log(partesSelect)
      let partesIds = partesSelect.map(part => part.value);
      let body = {
        empresa: clienteSelect?.value,
        partes: JSON.stringify(partesIds),
        inicio: inicio,
        fin: final,
        status: JSON.stringify(statusSelect)
      }
      searchData(body);
    }
  }

  return (
    <div className="collapser">
      <div className="collapser-label" onClick={toggleCollapser}>
        <span>Filtros de búsqueda</span>
        <span className="icon">
          <ExpandMore className={isOpen ? 'open' : ''} />
        </span>
      </div>
      <div className={`collapser-content ${isOpen ? 'open' : ''}`}>
        <form ref={formOrden} id="form_ord" style={{ width: '100%' }}>
          <Grid container spacing={0} sx={{ width: '100%' }}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: '0px 5px' }} className="center_item">
              <FormControl variant="outlined" sx={{ width: '100%' }}>
                <FormLabel id="companies">
                  Cliente(s)
                </FormLabel>
                <Autocomplete
                  fullWidth
                  id="emp_id"
                  getOptionLabel={(opcion) => opcion.label}
                  filterSelectedOptions
                  options={clientes}
                  onKeyDown={handleKeyUp}
                  value={clienteSelect}
                  onChange={(e, newValue) => {
                    changeClient(newValue)
                  }}
                  renderOption={(props, option) => (
                    <Box {...props} key={option?.value}>{option.label}</Box>
                  )}
                  renderInput={(params) =>
                    <TextField {...params} size="small" fullWidth />
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: '0px 5px' }} className="center_item">
              <FormControl variant="outlined" sx={{ width: '100%' }}>
                <FormLabel id="partes">
                  Parte(s)
                </FormLabel>
                <Autocomplete
                  fullWidth
                  id="part_id"
                  multiple
                  getOptionLabel={(opcion) =>
                    opcion?.codigo !== undefined ?
                      `${opcion?.label} / ${opcion?.codigo} / ${opcion?.codigo_salida}` :
                      opcion?.label
                  }
                  filterSelectedOptions
                  options={partes?.filter(p => p.emp_id === clienteSelect?.value)}
                  onKeyDown={handleKeyUp}
                  value={partesSelect}
                  onChange={(e, newValue) => {
                    setPartesSelect(newValue)
                  }}
                  renderOption={(props, option) => (
                    <Box {...props} key={option?.value}>
                      {option?.codigo !== undefined ? option?.codigo : <></>} /
                      {option?.codigo_salida !== undefined ? option?.codigo_salida : <></>} / {option?.label}
                    </Box>
                  )}
                  renderInput={(params) =>
                    <TextField {...params} size="small" fullWidth required />
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3} xl={3} sx={{ p: '0px 5px', mt: 2 }} className="center_item">
              <FormControl variant="outlined" fullWidth>
                <FormLabel id="start_date_label">
                  Fecha inicial
                </FormLabel>
                <TextField
                  id='filtro_start'
                  type="date"
                  fullWidth
                  size="small"
                  value={inicio}
                  name="filtro_start"
                  hiddenLabel
                  placeholder=""
                  onChange={(e) => setInicio(e.target.value)}
                  className="input-date"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3} xl={3} sx={{ p: '0px 5px', mt: 2 }} className="center_item">
              <FormControl variant="outlined" sx={{ width: '100%' }}>
                <FormLabel id="end_date_label">
                  Fecha final
                </FormLabel>
                <TextField
                  type="date"
                  size="small"
                  id="end_date"
                  fullWidth
                  value={final}
                  onChange={
                    (e) => setFinal(e.target.value)
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: '0px 5px', mt: 5, alignItems: "center", justifyContent: "center" }} className="center_item">
              <FormGroup sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }} row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={statusSelect.some(id => id === 1)}
                      onChange={() => changeStatus(1)}
                    />
                  }
                  label="Ingresos"
                />
                <FormControlLabel
                  control={
                    <Checkbox checked={statusSelect.some(id => id === 2)} onChange={() => changeStatus(2)} />
                  }
                  label="Shipper" />
                <FormControlLabel
                  control={
                    <Checkbox checked={statusSelect.some(id => id === 3)} onChange={() => changeStatus(3)} />
                  }
                  label="Apartado Salida"
                />
                <FormControlLabel
                  control={
                    <Checkbox checked={statusSelect.some(id => id === 4)} onChange={() => changeStatus(4)} />
                  }
                  label="Ajuste"
                />
                <FormControlLabel
                  control={
                    <Checkbox checked={statusSelect.some(id => id === 5)} onChange={() => changeStatus(5)} />
                  }
                  label="Cuarentena"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sx={{ p: '0px 5px', mt: 2, display: 'inline-flex', justifyContent: 'flex-end', gap: 4 }} className="center_item">
              {
                canDownXlsx &&
                <>
                  <Button
                    variant="outlined"
                    className="btn_system"
                    sx={{ maxWidth: '250px' }}
                    disabled={!canDownXlsx}
                    onClick={() => exportGeneral(inicio, final)}
                  >
                    Reporte Genera.xlsx
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn_system"
                    sx={{ maxWidth: '250px' }}
                    disabled={!canDownXlsx}
                    onClick={() => exportDetalle(inicio, final)}
                  >
                    Reporte Detalle.xlsx
                  </Button>
                </>
              }
              <Button
                variant="contained"
                className="btn_system"
                sx={{ maxWidth: '200px' }}
                onClick={sumbmitFiltro}
              >
                Buscar
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
      {
        showAlert &&
        <Alert severity="warning">Campos incompletos para la búsqueda</Alert>
      }
    </div>
  )
}